import React from 'react'

import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import {
  CommentLargeConfig,
  CommentMediumConfig,
  CommentSmallConfig,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config/index'
import { FlowChartCommentNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartCommentNode'
import { SizeType } from 'common/builder/nodes/comment/commentNodeConstants'

import { CardStyle } from './Comment.styles'
import { CommentNodeContent } from './components/CommentNodeContent'
import { CommentNodeEmpty } from './components/CommentNodeEmpty'

const configMap = {
  [SizeType.SMALL]: CommentSmallConfig,
  [SizeType.MEDIUM]: CommentMediumConfig,
  [SizeType.LARGE]: CommentLargeConfig,
}

export const Comment: NodeComponent<FlowChartCommentNode> = ({ node, builderId, container }) => {
  const { data } = node
  const { text, fontSize } = data
  const { isNoInteractions } = useFlowChartState()
  const config = configMap[data.nodeSize]

  return (
    <NodeContainer
      builderId={builderId}
      container={container}
      nodeId={node.id}
      disableFlowChartInteractions={isNoInteractions}
      width={config.width}
    >
      <view style={CardStyle}>
        {text.length > 0 ? (
          <CommentNodeContent textParts={text} fontSize={fontSize} />
        ) : (
          <CommentNodeEmpty
            placeholderText={config.placeholderText}
            placeholderTextColor={config.placeholderTextColor}
          />
        )}
      </view>
    </NodeContainer>
  )
}
